const messages = {
  'en': {
    'Incorrect authentication credentials.': 'Incorrect authentication credentials.',
    abort: 'Abort',
    addEntry: 'New Entry',
    addLiquidation: 'New Transfer',
    addPurchase: 'New Purchase',
    addReaction: 'Add Reaction',
    amount: 'Amount',
    average: 'Average',
    back: 'Back',
    beenHereBefore: 'You may want to go back to one of these',
    buyer: 'Buyer',
    cashingUp: 'Cashing Up',
    chooseMember: 'Who are you?',
    confirm: 'Confirm',
    confirmDeleteTransfer: 'Do you really want to delete this entry?',
    confirmLogout: 'Do you really want to logout?',
    create: 'Create',
    creditor: 'Creditor',
    de: 'Deutsch',
    debtor: 'Debtor',
    delete: 'Delete',
    description: 'Description',
    editLiquidation: 'Edit Transfer',
    editPurchase: 'Edit Purchase',
    en: 'English',
    explainCashingUp: 'The following steps are necessary to resolve all debt',
    explainLiquidation: 'A direct transfer between two people.',
    explainPurchase: 'You bought something for the group and the expense will be shared equally.',
    feed: 'Feed',
    financialStatus: 'Status',
    for: 'for',
    founded: 'Founded',
    gaveMoneyTo: 'paid to',
    isSplitDifferently: 'Split differently',
    language: 'Language',
    liquidation: 'Transfer',
    login: 'Enter',
    logout: 'Exit',
    markPaybackAsDone: 'Check off',
    matchingEntries: 'Entries',
    median: 'Median',
    members: 'Members',
    name: 'Name',
    newFromCopy: 'Copy',
    nothingToDo: 'There is currently nothing to do',
    overallDebt: 'Overall Transfers',
    overallPurchased: 'Overall Purchases',
    paidFor: 'paid for',
    password: 'Password',
    payback: 'Repayment',
    paypalMeHint: 'Pay via paypal.me',
    pays: 'pays',
    placeholderPurchaseName: 'Boombox',
    price: 'Price',
    purchase: 'Purchase',
    ranking: 'Ranking',
    readOnly: 'read-only',
    readOnlyAlert: 'This page is read-only and can not be modified',
    reloadPage: 'Reload Page',
    save: 'Save',
    swap: 'Tauschen',
    to: 'to',
    tooLong: 'Too long',
    unknownHint: 'You seem lost. You need to open this app from an invitation link.',
    usesIconsFrom: 'Uses icons from',
    weightsForAllPrompt: 'Please enter portion to be set for all:',
    weightsRadioOptionDifferent: 'Split differently',
    weightsRadioOptionEven: 'Split equal',
    weightsTableHeaderShare: 'Portion (e.g. number of days)',
    weightsTableHeaderWho: 'Who',
    whoAreYou: 'That\'s me',
  },
  'de': {
    'Incorrect authentication credentials.': 'Login fehlgeschlagen, bitte Daten prüfen.',
    abort: 'Abbrechen',
    addEntry: 'Neuer Eintrag',
    addLiquidation: 'Neue Zahlung',
    addPurchase: 'Neuer Einkauf',
    addReaction: 'Reaktion hinzufügen',
    amount: 'Betrag',
    average: 'Durchschnitt',
    back: 'Zurück',
    beenHereBefore: 'Vielleicht möchtest du wieder zurück gehen',
    buyer: 'Käufer',
    cashingUp: 'Kassensturz',
    chooseMember: 'Wer bist du?',
    confirm: 'Bestätigen',
    confirmDeleteTransfer: 'Willst du diesen Eintrag wirklich löschen?',
    confirmLogout: 'Willst du dich wirklich ausloggen?',
    create: 'Anlegen',
    creditor: 'Gläubiger',
    de: 'Deutsch',
    debtor: 'Schuldner',
    delete: 'Löschen',
    description: 'Beschreibung',
    editLiquidation: 'Zahlung bearbeiten',
    editPurchase: 'Einkauf bearbeiten',
    en: 'English',
    explainCashingUp: 'Die folgenden Schritte sind notwendig, um alle Schulden zu begleichen',
    explainLiquidation: 'Eine direkte Zahlung zwischen zwei Personen.',
    explainPurchase: 'Du hast etwas für die Gruppe eingekauft und die Kosten werden zwischen allen aufgeteilt.',
    feed: 'Feed',
    financialStatus: 'Status',
    for: 'für',
    founded: 'Gegründet',
    gaveMoneyTo: 'hat gezahlt an',
    isSplitDifferently: 'Anders aufgeteilt',
    language: 'Sprache',
    liquidation: 'Zahlung',
    login: 'Betreten',
    logout: 'Verlassen',
    markPaybackAsDone: 'Abhaken',
    matchingEntries: 'Einträge',
    median: 'Median',
    members: 'Mitglieder',
    name: 'Name',
    newFromCopy: 'Kopieren',
    nothingToDo: 'Aktuell gibt es nichts zu tun',
    overallDebt: 'Zahlungen insgesamt',
    overallPurchased: 'Einkäufe insgesamt',
    paidFor: 'bezahlte für',
    password: 'Passwort',
    payback: 'Rückzahlung',
    paypalMeHint: 'Zahle mit paypal.me',
    pays: 'zahlt',
    placeholderPurchaseName: 'Boombox',
    price: 'Preis',
    purchase: 'Einkauf',
    ranking: 'Rangfolge',
    readOnly: 'schreibgeschützt',
    readOnlyAlert: 'Diese Seite ist schreibgeschützt und kann nicht verändert werden',
    reloadPage: 'Seite neu laden',
    save: 'Speichern',
    swap: 'Swap',
    to: 'an',
    tooLong: 'Zu lang',
    unknownHint: 'Du scheinst dich verlaufen zu haben, du solltest die App über einen Einladungslink öffnen.',
    usesIconsFrom: 'Nutzt Icons von',
    weightsForAllPrompt: 'Bitte Anteil eingeben, der für alle gesetzt werden soll:',
    weightsRadioOptionDifferent: 'Anders aufteilen',
    weightsRadioOptionEven: 'Gleich aufteilen',
    weightsTableHeaderShare: 'Anteil (z.B. Anzahl Tage)',
    weightsTableHeaderWho: 'Wer',
    whoAreYou: 'Das bin ich',
  }
}

export default messages;
